import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";

class TextMessage extends Component {
    isLink(string){
        if(string.includes('https://') ||string.includes('http://'))
        {
          return true;
        }
        else{
          return false;
        }
      }
       extractLinkFunction =(message)=>{
       
        if(message.includes('href'))
        {
        message.match(/\bhttps?:\/\/\S+/gi)
        if (message.match(/"([^"]*)"/)[0].length >= 2 && message.match(/"([^"]*)"/)[0].charAt(0) == '"' && message.match(/"([^"]*)"/)[0].charAt(message.match(/"([^"]*)"/)[0].length - 1) == '"')
        {
            message = message.match(/"([^"]*)"/)[0].substring(1, message.match(/"([^"]*)"/)[0].length - 1)
        }
        return message;
        }
        else
           return message
      }
    render() {
        console.log("fl",this.props.isOnlyEmoji)
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
               {
                this.isLink(this.props.message.message.text) ?
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                   <a target="_blank" href ={this.extractLinkFunction(this.props.message.message.text)}>{this.props.message.message.text}</a> 
                    <br />
                </div>
                :<div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                {this.props.message.message.text}
                <br />
            </div>
               } 
                
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.message.message.sentTimestamp/1000)).format("h:mm a")}</div>}
            </div>
        )
    }

    showMessageTime = () => {
        return (this.props.message.type !== MessageType.info);
    }

    messageTimeClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-time-sent";
            case MessageType.received: return "s360-message-time-received";
            case MessageType.info: return "s360-message-time-info";
            default: return "";
        }
    }

    messageBoxClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-box-sent";
            case MessageType.received: return "s360-message-box-received";
            case MessageType.info: return "s360-message-box-info";
            default: return "";
        }
    }

    messageContainerClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-cotainer-sent";
            case MessageType.received: return "s360-message-cotainer-received";
            case MessageType.info: return "s360-message-cotainer-info";
            default: return "";
        }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
            case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.ReceiverMessageFont, fontSize: config.designDetails.ReceiverMessageFontSize, color: config.designDetails.recieverMessageFontColor, padding: config.designDetails.paddingText }
            case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            default: return {}
        }
    }
    emojiStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
            case MessageType.sent: return { background: "white", fontFamily: config.designDetails.ReceiverMessageFont, fontSize: config.designDetails.ReceiverMessageFontSize, color: config.designDetails.recieverMessageFontColor, padding: config.designDetails.paddingText }
            case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            default: return {}
        }
    }


    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        switch (this.props.message.type) {
            case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            default: return {}
        }
    }

}

export default TextMessage;
